import React, { useCallback } from "react";
import { FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { TaskSelectorProps, Task } from "./types";

// TaskOption component to prevent unnecessary re-renders
const TaskOption = React.memo(({ 
  task, 
  isSelected, 
  onChange 
}: { 
  task: Task; 
  isSelected: boolean;
  onChange: (value: string) => void;
}) => (
  <FormControlLabel
    key={task.name}
    value={task.name}
    control={
      <Radio
        sx={{
          color: "#a100ff",
          "&.Mui-checked": { color: "#a100ff" }
        }}
      />
    }
    label={task.name
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())}
    sx={{
      marginRight: 4,
      ".MuiFormControlLabel-label": {
        fontWeight: 500,
        fontSize: "0.75rem",
        letterSpacing: "0.02em",
      },
    }}
    onChange={() => onChange(task.name)}
  />
));

const TaskSelector: React.FC<TaskSelectorProps> = ({
  filteredTasks,
  selectedTask,
  setSelectedTask,
  searchOption,
  setSearchOption,
  theme
}) => {
  const handleTaskChange = useCallback((value: string) => {
    setSearchOption(value);
    const task = filteredTasks.find((t: Task) => t.name === value);
    setSelectedTask(task || null);
  }, [filteredTasks, setSearchOption, setSelectedTask]);

  return (
    <div
      className={`z-10 sticky top-0 px-10 pt-6 pb-2 ${
        theme.name === "dark-theme"
          ? "bg-[#1d1d1d]"
          : "bg-[#faf5ff]"
      }`}
    >
      <p
        className={`font-bold mb-2 ${
          theme.name === "dark-theme"
            ? "text-white"
            : "text-black"
        }`}
        style={{ textTransform: "none" }}
      >
        SEARCH AGENT SUITE
      </p>
      <FormControl
        className={`${
          theme.name === "dark-theme"
            ? "text-white"
            : "text-black"
        }`}
        component="fieldset"
      >
        <RadioGroup
          row
          value={searchOption}
          onChange={(e) => handleTaskChange(e.target.value)}
        >
          {filteredTasks.map((task: Task) => (
            <TaskOption 
              key={task.name}
              task={task}
              isSelected={searchOption === task.name}
              onChange={handleTaskChange}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <hr className="mt-4 border-t-2 border-gray-400" />
    </div>
  );
};

export default React.memo(TaskSelector);